import { decodeJwt, type JWTPayload } from 'jose';

const decodeJWT = (token: string): JWTPayload | null => {
  try {
    return decodeJwt(token);
  } catch (error) {
    return null;
  }
};

export default decodeJWT;
